import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import { ChartConfiguration } from 'chart.js';
import { UserService } from 'src/app/core/user.service';
import { BlendEvent, PermissionActions, User, UserDiskUsageApiOutput, UserInfoSetApiInput, UserInfoSetApiOutput } from 'src/app/shared/models';
import { ApiService } from 'src/app/core/api.service';
import { LoggerService } from 'src/app/core/logger.service';
import { HIGH_USAGE_COLORS, LOW_USAGE_COLORS, MEDIUM_USAGE_COLORS, UNLIMITED_USAGE_COLORS, UsageType } from './billing.model';
import { BillingDocument, ZBillingQueue, zAccountInfo } from 'src/app/shared/models/api/orderprofile-api.model';
import { ZuoraAccountService } from 'src/app/account/services/zuora-account.service';
import { UtilService, ListItem, Pagination } from '@material-library';
import { ActivatedRoute, Router } from '@angular/router';
import { BlendService } from 'src/app/shared/services/blend.service';
import { PlanDetailsApiOutput, PlanTerm } from 'src/app/shared/models/api/plandetails.model';
import { MultiAdminService } from 'src/app/core/multiadmin.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { B64Pipe } from 'src/app/shared/pipes/b64.pipe';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { PageEvent } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { SkuService } from 'src/app/shared/services/sku.service';
import { BillingService } from './billing.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { PurchaseUsersComponent } from 'src/app/users-roles/users/purchase-users/purchase-users.component';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { CommentService } from 'src/app/core/comment.service';

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss'],
  providers: [MultiAdminService]
})
export class BillingComponent implements OnInit, OnDestroy {
  @Input() showSendInvoiceDialog: boolean;
  public user: User;
  public zprofile: zAccountInfo;
  public zbillingqueue: ZBillingQueue[] = [];
  public zbillingqueuepending: ZBillingQueue[] = [];
  public planName: string;
  public planSku: string;
  public planStart: number;
  public planExpiry: number;
  public paidThru: number;
  public planExpiryClose: boolean;
  public cancelInFuture: boolean;
  public currentTerm: string;
  public renewalDate: string;
  public canManageBilling: boolean;
  public showPurchaseUsersOption: boolean = false;
  public planDetails: PlanDetailsApiOutput;
  public usersLimit: number;
  public totalUsers: number = 0;
  public limit: number = 0;
  public usageType: UsageType;
  public isLoading: boolean = false;
  public isPlanLoading: boolean = false;
  public permissionActions = PermissionActions;

  public doughnutChartLabels: string[] = ['Vault', 'Files', 'Available'];
  public doughnutChartOptions: ChartConfiguration<'doughnut'>['options'] = {
    responsive: true,
    cutout: 41,
    aspectRatio: 1,
    hover: { mode: null },
    plugins: {
      tooltip: {
        enabled: false,
      }
    }
  };
  public doughnutChartDatasets: ChartConfiguration<'doughnut'>['data']['datasets'];
  public chartColors: Array<string> = LOW_USAGE_COLORS;

  public DU_STATUS_INIT = 0;
  public DU_STATUS_SUCCESS = 1;
  public DU_STATUS_INVALID = 2;
  public du = {
    status: 0,
    spinner: false,
    vaultbytes: 0,
    vaultpercent: 0,
    syncbytes: 0,
    syncpercent: 0,
    unusedbytes: 0,
    usagePercentage: 0
  };

  public buttonColor: 'default' | 'critical' | 'warning' = 'default';

  public isAutoRenewDialogOpen: boolean = false;
  public isAutoRenewLoading: boolean = false;
  public autoRenew: boolean = false;
  public autoRenewDescription: string = ``;

  public profileExists = false;
  public recordScrubbed = false;

  listItemsForBilling: ListItem[] = [];

  public accountInfo: zAccountInfo;
  public invoices: ListItem[] = [];
  public invoiceListItems: ListItem[] = [];
  public selectedInvoice: BillingDocument;
  public onSendInvoice: boolean = false;
  public deviceInputError: boolean = false;
  public emails: string[] = [];
  public isSendDisabled : boolean = true;

  public pageObj: any = {
    pageIndex: 0,
    pageSize: 10,
    previousPageIndex: 0,
    length: 0,
    pageSizeOptions: [10, 20, 30, 40, 50, 100],
    alignment: 'right',
    onPageChange: (event: PageEvent) => { },
  };
  private sub: Subscription;
  public addPaymentMethodList:ListItem[] = [];

  public isSMScreen: boolean = false;
  private zuoraSubscription: Subscription;
  private breakpointSubscription: Subscription;
  public isBillingContextSet = false;
  constructor(
    private apiService: ApiService,
    private loggerService: LoggerService,
    public userService: UserService,
    private zuoraAccountService: ZuoraAccountService,
    private utilService: UtilService,
    private router: Router,
    private blendService: BlendService,
    private multiadminService: MultiAdminService,
    private b64: B64Pipe,
    private snackbarService: SnackbarService,
    private store: Store<fromRoot.State>,
    private skuService: SkuService,
    private billingService: BillingService,
    public breakpointObserver: BreakpointObserver,
    private dialogService: DialogService,
    private route: ActivatedRoute,
    private commentService:CommentService,
  ) { }

  async ngOnInit() {
    this.pageObj = {
      length: 0,
      pageSize: 10,
      pageSizeOptions: [10, 20, 30, 40, 50, 100],
      alignment: 'right',
      onPageChange: this.handlePageChange,
    };
    this.user = this.userService.getUser();
    this.planName = this.user.plan_name;
    this.sub = this.store
      .select(fromRoot.getAuthState)
      .subscribe((data) => {
        if (!data.authenticated) {
          this.loggerService.info('User is not authenicated');
          this.user = new User();
          return;
        }
        if (data.user) {
          this.user = data.user;
        }
      });

    this.breakpointSubscription = this.breakpointObserver
      .observe(['(max-width: 905px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.isSMScreen = true;
        } else {
          this.isSMScreen = false;
        }
      });
    this.addPaymentMethodList = [{
      primaryText: "No payment methods on file.",
      trail2AdornmentConfig: {
        enabled: true,
        type: 'button',
        size: 'large',
        buttonConfig: {
          label: 'Add a payment method',
          type: 'filled',
          size: 'large',
          color: 'default',
        },
        onClick: () => {
          this.router.navigate(['/settings/billing/profile']);
        }
      }
    }];
    this.init();
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.zuoraSubscription) {
      this.zuoraSubscription.unsubscribe();
    }
    if (this.breakpointSubscription) {
      this.breakpointSubscription.unsubscribe();
    }
  };

  private async init() {
    this.isLoading = true;
    this.usersLimit = this.userService.MAX_USERS;
    this.canManageBilling = this.userService.checkPermission(PermissionActions.MANAGE_BILLING);
    if (this.userService.checkPermission(PermissionActions.VIEW_BILLING)) {
      this.loadBillingProfile();
    } else {
      this.planExpiry = this.user.account_duedate;
      this.isLoading = false;
    }
    
    this.isPlanLoading = true;
    if (this.du.status == this.DU_STATUS_INIT) {
      await this.getDiskUsage();
    }
    
    if (this.userService.checkPermission(PermissionActions.ADD_EDIT_USERS)) {
      try {
        this.planDetails = await this.apiService.execute<PlanDetailsApiOutput>('getPlanDetails', {});
        if (this.planDetails.success && parseInt(this.planDetails.plan_user_limit, 10) < this.usersLimit) {
          this.showPurchaseUsersOption = true;
          const result = await this.multiadminService.getUserList();
          this.totalUsers = result.users.length;
          this.limit = result.user_limit;
        }
      } catch (error) {
        this.loggerService.e('Failed to load getPlanDetails', error);
      }
      
    }
    this.isPlanLoading = false;
  }
  addPaymentMethodClick = ()=>{
    this.router.navigate(['/settings/billing/profile']);
  }

  private async getDiskUsage() {
    
    this.du.unusedbytes = this.user.disk_limit_bytes - this.user.disk_usage_bytes;
    let vaultBytes = 0;
    try {
      const result = await this.apiService.execute<UserDiskUsageApiOutput>(
        'userdiskusage',
        {
          sync_pid: this.user.web_sync_id,
        }
      );
      vaultBytes = result.bytes;
    } catch (ex) {
      vaultBytes = 0;
      this.loggerService.error(ex);
    }

    // some legacy
    if (vaultBytes > this.user.disk_usage_bytes) {
      this.loggerService.warn(
        `Vault bytes ${vaultBytes} < usage bytes ${this.user.disk_usage_bytes}`
      );
      this.loggerService.warn('User needs disk usage/vault bytes recalculated');
      this.du.syncbytes = this.user.disk_usage_bytes;
      this.du.syncpercent =
        (this.user.disk_usage_bytes / this.user.disk_limit_bytes) * 100;
      this.du.unusedbytes =
        this.user.disk_limit_bytes - this.user.disk_usage_bytes;
      this.du.status = this.DU_STATUS_INVALID;
      return;
    }

    this.du.syncbytes = this.user.disk_usage_bytes - vaultBytes;
    this.du.vaultbytes = vaultBytes;
    this.du.syncpercent = Math.ceil(
      (this.du.syncbytes / this.user.disk_limit_bytes) * 100
    );
    this.du.vaultpercent = Math.ceil(
      (this.du.vaultbytes / this.user.disk_limit_bytes) * 100
    );
    this.du.usagePercentage = Math.ceil(
      (this.user.disk_usage_bytes / this.user.disk_limit_bytes) * 100
    );

    this.du.status = this.DU_STATUS_SUCCESS;

    if (this.user.is_unlimited_plan) {
      this.chartColors = UNLIMITED_USAGE_COLORS;
    } else {
      this.usageType = UsageType.LOW;
      this.chartColors = LOW_USAGE_COLORS;
      this.buttonColor = 'default';
      if (this.du.usagePercentage > 40 && this.du.usagePercentage < 80) {
        this.usageType = UsageType.MEDIUM;
        this.chartColors = MEDIUM_USAGE_COLORS;
        this.buttonColor = 'warning';
      } else if (this.du.usagePercentage > 80) {
        this.usageType = UsageType.HIGH;
        this.chartColors = HIGH_USAGE_COLORS;
        this.buttonColor = 'critical';
      }
    }

    this.doughnutChartDatasets = [
      {
        data: [this.du.vaultpercent, this.du.syncpercent, 100 - (this.du.syncpercent + this.du.vaultpercent)],
        label: 'Series A',
        borderWidth: 0,
        backgroundColor: this.chartColors,
      },
    ];
  };

  onUpgradePlan() {
    if (this.user.is_on_trial && this.zprofile && !this.zprofile.defaultPaymentMethod) {
      this.router.navigate(['/settings/billing/profile']);
    } else {
      this.blendService.addEventsForUpgradeButton();
      this.router.navigate(['/account/upgrade']);
    }
  };

  onRenewClick() {
      this.router.navigate(['/account/renew']);
  }

  private loadBillingProfile() {
    let refreshCallCount= 0;
    this.zuoraSubscription = this.zuoraAccountService.getSubscription().subscribe(data => {
      if (data.isLoaded) {
        if (this.route.snapshot.queryParams['newprofile'] == 0 && data.zprofile && data.zprofile?.defaultPaymentMethod) {
          this.zuoraAccountService.refresh();
        } else if (this.route.snapshot.queryParams['newprofile'] == 1 && data.zprofile && !data.zprofile?.defaultPaymentMethod) {
          this.zuoraAccountService.refresh();
        } else if (
          this.zuoraAccountService.zprofileLocalCopyForDataRefresh 
          && this.route.snapshot.queryParams['newprofile'] == 1 
          && data.zprofile && data.zprofile?.defaultPaymentMethod 
          && this.commentService.deepJSON_EqualCheck(data.zprofile.billToContact,this.zuoraAccountService.zprofileLocalCopyForDataRefresh.billToContact)
          && refreshCallCount < 10
        ) {
          refreshCallCount++;
          this.zuoraAccountService.refresh();
        } else {
          this.zprofile = data.zprofile;
          this.zuoraAccountService.zprofileLocalCopyForDataRefresh = undefined;
          refreshCallCount= 0;
          this.zbillingqueue = data.zbillingqueue;
          this.zbillingqueuepending = this.zbillingqueue.filter((bq) => bq.status === 'pending');
          if (this.zprofile?.subscription) {
            this.planName = this.zprofile.subscription.productFullName;
            this.autoRenew = this.zprofile.autoPay;
            if (this.zprofile?.renewalDate) {
              this.renewalDate = this.utilService.formatDate(this.zprofile.renewalDate, 'MMM d, y');
            }
          }

          if (this.zprofile.subscription) {
            this.planName = this.zprofile.subscription.productFullName;
            this.autoRenew = this.zprofile.autoPay;
            this.planSku = this.zprofile.subscription.sku;
            this.cancelInFuture = this.zprofile.subscription.status === 'Cancelled';

            this.planExpiry = this.user.is_on_trial
              ? this.userService.dateConversionForTrials(this.zprofile.subscription.termEndDate, this.user.is_on_trial).getTime()
              : this.billingService.getDateFromTerm(this.zprofile.subscription.termEndDate);
            this.planStart = this.billingService.getDateFromTerm(this.zprofile.subscription.termStartDate);
            this.paidThru = this.billingService.getDateFromTerm(this.zprofile.paidThroughDate);

            this.currentTerm = this.skuService.getPlanTerm(this.planSku);

            switch (this.currentTerm) {
              case PlanTerm.ANNUAL:
                this.planExpiryClose = (this.planExpiry <= Date.now() + 86400000 * 30);
                break;
              case PlanTerm.MONTHLY:
                this.planExpiryClose = (this.planExpiry <= Date.now() + 86400000 * 15);
                break;

              default:
                this.planExpiryClose = (this.planExpiry <= Date.now() + 86400000 * 30);
                break;
            }
            console.log(`${this.planExpiry} <= ${Date.now() + 8640000 * 30} > 86400000 * 30`);
          }

          this.recordScrubbed = (this.zprofile.name === 'Record scrubbed');
          if (this.zprofile && this.zprofile.accountNumber && !this.recordScrubbed) {
            this.profileExists = true;
          }
          this.setListItemsForBilling();
          this.setAutoRenewDescription();
          this.loadInvoices();
        }
        this.isLoading = false;
      }
    });
  };

  setListItemsForBilling = () => {
    let paymentType: string = '';
    let primaryText: string = '';
    let secondaryText: string = '';
    if (this.zprofile && this.profileExists && ((this.user.is_multi_new && !this.user.zuora_acct_key) || (!this.user.is_multi_new && this.user.zuora_acct_key))) {
      if (this.zprofile.defaultPaymentMethod && this.zprofile.defaultPaymentMethod.id) {
        paymentType = `Payments made by `;
        if (this.zprofile.defaultPaymentMethod.PaypalEmail) {
          paymentType += `PayPal: ${this.zprofile.defaultPaymentMethod.PaypalEmail}`;
        }
        if (this.zprofile.defaultPaymentMethod.creditCardType) {
          paymentType += `${this.zprofile.defaultPaymentMethod.creditCardType}
          ${this.zprofile.defaultPaymentMethod.creditCardNumber}`;
        }
        if (this.zprofile.defaultPaymentMethod.paymentMethodType == 'Other') {
          paymentType += `Bitcoin`
        }
      } 
      const name = this.zprofile.billToContact.firstName + ' ' + this.zprofile.billToContact.lastName;
      const company = this.zprofile.name != name ? this.zprofile.name : '';
      primaryText = name;
      secondaryText = `${company + '<br>'} ${this.b64.transform(this.zprofile.billToContact.address1)} ${this.zprofile.billToContact.city} ${this.zprofile.billToContact.state} ${this.zprofile.billToContact.zipCode} ${this.zprofile.billToContact.country}`;

    }
    this.isBillingContextSet = !!primaryText;
    this.listItemsForBilling = [
      {
        primaryText,
        secondaryText,
        'tertiaryText': paymentType,
        showActions: true,
        actionsConfig: {
          limit: 1,
          rowData: {},
          actions: [
            ...(this.canManageBilling ? [{
              name: 'Edit auto renew setting',
              icon: '',
              onClick: this.onAutoRenewDialogClick,
              isDisabled:()=>this.canManageBilling && this.zprofile?.defaultPaymentMethod?.paymentMethodType == 'Other'
            }] : []), {
              name: 'Change billing profile',
              icon: '',
              onClick: () => {
                this.zuoraAccountService.zprofileLocalCopyForDataRefresh = this.zprofile;
                this.router.navigate(['/settings/billing/profile']);
              },
            }
          ]
        }
      }
    ];
  };
  setAutoRenewDescription = () => {
    this.autoRenewDescription = `Auto renew has been ${!this.zprofile ? this.user.is_disableautorenew ? 'disabled' : 'enabled' : this.zprofile && this.zprofile.autoPay ? 'enabled' : 'disabled'}. Keep your subscription active after your renewal date by turning on auto renew.`;
  };
  onAutoRenewDialogClick = () => {
    this.autoRenew = this.zprofile.autoPay;
    this.isAutoRenewDialogOpen = true;
  };
  onCancelAutoRenewDialog = async () => {
    this.isAutoRenewDialogOpen = false;
  };

  toggleRenewSwitch = (event: MatSlideToggleChange) => {
    this.autoRenew = event.checked;
  };
  saveAutoRenew = async () => {
    try {
      this.isAutoRenewLoading = true;
      await this.apiService.execute<UserInfoSetApiOutput>('userinfoset', <UserInfoSetApiInput>{
        is_disableautorenew: this.autoRenew ? 0 : 1
      });
      this.blendService.track(BlendEvent.CHANGE_ACCOUNT_SETTING, {is_auto_renew_enabled: this.autoRenew});
      this.userService.refresh();
      this.zuoraAccountService.refresh();
      this.isAutoRenewDialogOpen = false;
      this.snackbarService.showMessage('success', 'Auto renew ' + (this.autoRenew ? 'enabled.' : 'disabled.'));
    } catch (ex) {
      this.loggerService.error('An error occurred saving auto renew settings');
      this.snackbarService.showMessage(
        'critical',
        "Couldn't complete action. Try again."
      );
    } finally {
      this.isAutoRenewLoading = false;
      this.isAutoRenewDialogOpen = false;
    }
  };

  public loadInvoices() {
    try {
      if (this.zprofile && this.zprofile?.billingDocuments) {
        this.invoices = this.zprofile.billingDocuments.map((invoice) => {
          invoice = {...invoice, date: this.utilService.formatDate(new Date(invoice.date), 'MMM d, y')}
          return {
            ...( (invoice.balance !== 0 && invoice.type === 'invoices') && {
                ...(!this.isSMScreen && {leadAdornmentConfig: {
                  enabled: true,
                  type: 'icon',
                  size: 'large',
                  iconName: 'error',
                  iconType: 'error'
                }}),
                errorTertiaryText: 'Invoice is unpaid. Pay now to continue using Sync.',
                trail1AdornmentConfig: {
                  enabled: true,
                  type: 'button',
                  size: 'small',
                  buttonConfig: {
                    label: 'Pay now',
                    size: 'small',
                    type: 'filled',
                    color: 'critical'
                  },
                  onClick: () => {
                    this.router.navigate(['/account/renew']);
                  }
                }
              }
            ),
            primaryText: invoice.number,
            secondaryText: invoice.date,
            wrap: true,
            ...( !this.isSMScreen ? {trail2AdornmentConfig: {
                enabled: true,
                type: 'text',
                size: 'large',
                textContent: this.formatCurrency(invoice.amount)
              }
            } : {
              tertiaryText: this.formatCurrency(invoice.amount)
            }),
            showActions: true,
            actionsConfig: {
              limit: 1,
              rowData: invoice,
              actions: [
                {
                  name: 'Send invoice',
                  icon: 'send',
                  onClick: this.onSendInvoiceClick,
                }
              ]
            }
          };
        });
        this.pageObj.pageIndex = 0;
        this.handlePageChange(this.pageObj);
      }
    } catch (error) {
      this.loggerService.error(error);
    }
  };

  // Helper method to format amount as USD currency string
  private formatCurrency(amount: number): string {
    const formattedAmount = amount.toFixed(2); // Round to 2 decimal places
    return `$${formattedAmount}`; // Prefix with '$' symbol
  }

  onCancelClick = () => {
    this.onSendInvoice = false;
  };

  onSendInvoiceClick = async (rowData: BillingDocument) => {
    this.onSendInvoice = true;
    this.selectedInvoice = rowData;
  };

  onEmailChange = (data) => {
    this.emails = data
  };


  sendEmail = async () => {
    try {
      await this.zuoraAccountService.emailBillingDocument(this.emails, this.selectedInvoice.type, this.selectedInvoice.id)
      this.snackbarService.showMessage('success', 'Invoice sent. Please allow up to 15 minutes for delivery.', { config: { autoClose:true, duration: 5000 } });
    } catch (error) {
      this.snackbarService.showMessage(
        'critical',
        "Couldn't complete action. Try again."
      );
    } finally {
      this.onSendInvoice = false;
    }
  };

  handlePageChange = (event: PageEvent) => {
    const fromIndex = event.pageIndex * event.pageSize;
    const toIndex = fromIndex + event.pageSize;
    this.invoiceListItems = this.invoices.slice(fromIndex, toIndex);

    this.pageObj = {
      pageIndex: event.pageIndex,
      pageSize: event.pageSize,
      previousPageIndex: event.previousPageIndex,
      length: this.invoices.length,
      pageSizeOptions: [10, 20, 30, 40, 50, 100],
    };
  };

  public clickPurchaseUsers = () => {
    this.dialogService.open(PurchaseUsersComponent);
  }
  
  canRenew = () => {
    return ((this.planExpiry && this.planExpiryClose) || (this.zprofile && this.zprofile.balance !== 0)) && !this.cancelInFuture && !this.user.is_on_trial;
  }

  public get canPurchaseUsers() {
    return this.userService.checkPermission(PermissionActions.MANAGE_BILLING) && this.limit < this.userService.MAX_USERS;
  }

}
